// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"19ba9f4f","975":"69604013"}[chunkId] + ".chunk.css";
};